var NonPublicProject =function(src) {
    var self = this;
    src = src || {};
    self.ProjectId = src.ProjectId || 0;
    self.ProjectOrganizationId = src.ProjectOrganizationId ||0;
    self.ProjectOrganizationName = src.ProjectOrganizationName || '';
    self.Experience = src.Experience || '';
    self.USDAInitiative = src.USDAInitiative || '';
    self.PartnerOrganizationId = src.PartnerOrganizationId || 0;
    self.ProjectDescription = src.ProjectDescription || '';
    self.ResultsAchieved = src.ResultsAchieved || '';
    self.ProjectPartners = src.ProjectPartners || '';
    self.LessonsLearned = src.LessonsLearned || '';
    self.ProjectContinuation = src.ProjectContinuation || 0; 
    self.ForestName = src.ForestName || '';
    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
    self.CreatedDate = src.CreatedDate || new Date();
    self.CreatedDateString = src.CreatedDateString || '';
    self.CreatedBy = src.CreatedBy || '';
    self.LastUpdated = src.LastUpdated || new Date();
    self.LastUpdatedString = src.LastUpdatedString || '';
    self.LastUpdatedBy = src.LastUpdatedBy || '';
    self.UpdatingApp = src.UpdatingApp || '';
    self.ProjectHours = src.ProjectHours || [];
    return self;
}
angular.module('jcsfApp').value('NonPublicProject', NonPublicProject);